import styled from 'styled-components'

export const RelatedArticleItem = styled.div`
  > a {
    text-decoration: none;
  }

  &:hover {
    box-shadow: 0px 16px 16px -8px rgba(0, 0, 0, 0.1);
  }

  width: 384px;
  background: #ffffff;
  cursor: pointer;

  &:not(:last-of-type) {
    margin-right: 24px;
  }

  .RelatedArticle__Item-Icon {
    position: absolute;
    right: 1px;
    bottom: 1px;
    height: 48px;
    width: 48px;
  }

  ${p => p.theme.breakpoints.down('md')} {
    width: 304px;
  }

  ${p => p.theme.breakpoints.down('sm')} {
    width: 360px;
    &:nth-of-type(1) {
      margin-right: 16px;
    }
    &:nth-of-type(2) {
      margin: 0;
    }
    &:nth-of-type(3) {
      margin-top: 16px;
    }
  }

  ${p => p.theme.breakpoints.down('xs')} {
    max-width: 329px;
    width: 100%;
    &:nth-of-type(1) {
      margin: 0;
    }
    &:nth-of-type(2),
    &:nth-of-type(3) {
      margin-top: 16px;
    }
  }
`

export const RelatedArticleContainer = styled.div`
  ${(p: any) => {
    let topPadding, bottomPadding
    if (p.topPadding === 'Large') {
      topPadding = '96px'
    } else if (p.topPadding === 'Small') {
      topPadding = '64px'
    } else {
      topPadding = '0'
    }

    if (p.bottomPadding === 'Large') {
      bottomPadding = '96px'
    } else if (p.bottomPadding === 'Small') {
      bottomPadding = '64px'
    } else {
      bottomPadding = '0'
    }

    return `
      padding: ${topPadding} 0 ${bottomPadding};
      ${
        p.isHomePage
          ? `
        ${p.theme.breakpoints.up('md')} {
          padding-top: 1px; // applied for negative margins
        }
        .RelatedArticle__Outer-Container {
          margin-top: -81px;
          ${p.theme.breakpoints.down('md')} {
            margin-top: -69px;
          }
          ${p.theme.breakpoints.down('sm')} {
            margin-top: 0;
          }
        }
      `
          : ``
      }

    `
  }}
  background: rgb(247, 247, 247);

  .RelatedArticle__Heading {
    color: #000;
    font-family: 'Inter', sans-serif;
    font-size: 36px;
    font-weight: 800;
    line-height: 44px;
    margin-bottom: 48px;
  }

  .RelatedArticle__Card-Container {
    display: flex;
    justify-content: center;

    ${p => p.theme.breakpoints.down('sm')} {
      flex-wrap: wrap;
      margin: 0 auto;
      justify-content: start;
    }

    ${p => p.theme.breakpoints.down('xs')} {
      max-width: 328px;
    }
  }

  .RelatedArticle__Image-Container {
    width: 100%;
    position: relative;

    img {
      object-fit: cover;
      object-position: center;
    }

    .RelatedArticle__BackgroundImg {
      width: 100%;
      height: 192px;
    }
  }

  .RelatedArticle__Text-Container {
    padding: 0 24px;
    position: relative;
    margin-top: 32px;

    > *:first-child {
      margin-top: 0;
    }

    ${p => p.theme.breakpoints.down('md')} {
      margin-top: 24px;
    }
  }

  .RelatedArticle__Info-Container {
    display: flex;
    padding: 0 24px;
    position: relative;
    margin-top: 32px;

    > *:first-child {
      margin-top: 0;
    }

    ${p => p.theme.breakpoints.down('md')} {
      margin-top: 24px;
    }
  }

  .RelatedArticle__Item-Date {
    font-size: 12px;
    letter-spacing: 0.5px;
    line-height: 16px;
    color: #8a97a0;
    margin-left: auto;
  }

  .RelatedArticle__Item-Category {
    font-size: 14px;
    text-transform: uppercase;
    color: #8b97a1;
    font-weight: 800;
  }

  .RelatedArticle__Item-Heading {
    margin: 40px 0;
    word-wrap: break-word;
    a {
      color: inherit;
    }
    &:hover {
      color: #0067df;
    }
    font-family: 'Inter', sans-serif;
    font-size: 20px;
    font-weight: 800;
    color: #273139 !important;
    line-height: 24px;
  }
`
